// TestContent.js
import React from 'react';

const Promotions = () => {
  return (
    <div>
      <h1>Promotion</h1>
      <p>This content is coming from the TestContent component.</p>
    </div>
  );
};

export default Promotions;
